import { render, staticRenderFns } from "./CompaniesReportsHome.vue?vue&type=template&id=7fb55bea&scoped=true"
import script from "./CompaniesReportsHome.vue?vue&type=script&lang=js"
export * from "./CompaniesReportsHome.vue?vue&type=script&lang=js"
import style0 from "./CompaniesReportsHome.vue?vue&type=style&index=0&id=7fb55bea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb55bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb55bea')) {
      api.createRecord('7fb55bea', component.options)
    } else {
      api.reload('7fb55bea', component.options)
    }
    module.hot.accept("./CompaniesReportsHome.vue?vue&type=template&id=7fb55bea&scoped=true", function () {
      api.rerender('7fb55bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/CompaniesReportsHome.vue"
export default component.exports